import React, { useState } from 'react';
import * as moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';
import '../../i18n';
import { useMediaQuery, getRegionWithException } from '../../helpers';
import HeaderMobile from './HeaderMobile';
import HeaderMedium from './HeaderMedium';
import StartDateInput from './StartDateInput';
import EndDateInput from './EndDateInput';
import KeywordsInput from './KeywordsInput';
import RegionsInput from './RegionsInput';
import CategoriesInput from './CategoriesInput';
import EvenTypeButton from './EvenTypeButton';

const Header = (props) => {
    const { t } = useTranslation();
    const { handleFilters, locale } = props;

    const [keywords, setKeywords] = useState('');
    const [categories, setCategories] = useState('');
    const [regionsValue, setRegions] = useState('');
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();

    // @media property
    const isDesktop = useMediaQuery('screen and (min-width: 1280px)');
    const isMobile = useMediaQuery('screen and (max-width: 680px)');


    const eventsCount = (events, type) => {
        const now = moment();

        if (events.length) {
            if (type === 'past') {
                return events.filter(event => moment(event.end_date) < now).length;
            } else {
                return events.filter(event => moment(event.end_date) > now).length;
            }
        }
    }

    const getImageFromStorage = () => {
        return props.data.settings.logo_url || props.data.settings.organization_logo_url || '';
    };

    const handleChangeOnKeywords = (event) => {
        const value = event.target.value;

        handleFilters('keywords', value);
        setKeywords(value);
    };

    const handleChangeOnCategories = (value) => {
        handleFilters('categories', value);
        setCategories(value);
    };

    const handleChangeOnRegions = (value) => {
        handleFilters('regions', value);
        setRegions(value);
    };

    const resetFiltersInputs = () => {
        setKeywords('');
        setCategories('');
        setRegions('');
        setStartDate('');
        setEndDate('');
    }

    // filter categories
    const categoriesOption = props.data.categories.map((category) => {
        return {
            value: category.id,
            label: category.name
        }
    });

    // filter regions
    const regions = props.data.events.map((event) => {
        return {
            value: event.venue.country_code,
            label: getRegionWithException(event.venue)
            // label: event.venue.region
        }
    });

    // console.log({regions});

    const regionsOption = regions
        .filter(option => option.label)
        .filter((element, index, regions) => regions.findIndex(el => (el.value === element.value && el.label === element.label)) === index);

    const eventsTypeArr = ['all', 'past', 'upcoming'];

    {
        return (
            isDesktop
                ? (
                    <header className="helvetica px-3 py-5" style={{ backgroundColor: props.data.settings.header_color || props.data.settings.organization_header_color || '#fff' }}>
                        <div className="flex z-10 w-full">
                            <div className="header-b-l">
                                {
                                    props.data.settings.logo_url || props.data.settings.organization_logo_url ?
                                        <img src={`${props.data.settings.logo_url || props.data.settings.organization_logo_url}`} className="img-width" alt="header-logo" />
                                        : null
                                }
                            </div>
                            <div className="w-full">
                                <div className="filter-container">
                                    <div className="flex mb-6 justify-between">
                                        <StartDateInput
                                            handleFilters={handleFilters}
                                            locale={locale}
                                            startDate={startDate}
                                            setStartDate={setStartDate}
                                            isDesktop={isDesktop}
                                        />
                                        <EndDateInput
                                            handleFilters={handleFilters}
                                            locale={locale}
                                            endDate={endDate}
                                            setEndDate={setEndDate}
                                            isDesktop={isDesktop}
                                        />
                                    </div>

                                    <div className="flex flex-wrap -mx-3 mb-2">
                                        <KeywordsInput
                                            handleFilters={handleFilters}
                                            locale={locale}
                                            keywords={keywords}
                                            handleChangeOnKeywords={handleChangeOnKeywords}
                                        />
                                        <CategoriesInput
                                            handleFilters={handleFilters}
                                            locale={locale}
                                            categories={categories}
                                            categoriesOption={categoriesOption}
                                            handleChangeOnCategories={handleChangeOnCategories}
                                            isDesktop={isDesktop}
                                        />
                                        <RegionsInput
                                            handleFilters={handleFilters}
                                            locale={locale}
                                            regionsValue={regionsValue}
                                            regionsOption={regionsOption}
                                            handleChangeOnRegions={handleChangeOnRegions}
                                            isDesktop={isDesktop}
                                        />
                                    </div>
                                    <div className="flex flex-wrap -mx-3 mt-3 pt-2.5 justify-center relative">
                                        {eventsTypeArr.map((type) => {
                                            return <EvenTypeButton
                                                handleFilters={handleFilters}
                                                filters={props.filters}
                                                settings={props.data.settings}
                                                data={props.data}
                                                typeEvent={type}
                                                eventsCount={eventsCount}
                                                isDesktop={isDesktop}
                                                isMobile={isMobile}
                                            />
                                        })}
                                        <div
                                            className="absolute text-ed-grey underline right-3 top-1.5 text-sm cursor-pointer font-light"
                                            onClick={() => { handleFilters('type', 'reset_filters'); resetFiltersInputs() }}>
                                            {t('reset_filters')}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="header-b-r"></div>
                        </div>
                    </header>
                )
                : isMobile
                    ?
                    < HeaderMobile
                        data={props.data}
                        filters={props.filters}
                        getImageFromStorage={getImageFromStorage}
                        handleFilters={handleFilters}
                        locale={locale}
                        categoriesOption={categoriesOption}
                        regions={regions}
                        regionsOption={regionsOption}
                        eventsCount={eventsCount}
                        eventsTypeArr={eventsTypeArr}
                        isDesktop={isDesktop}
                    />
                    :
                    < HeaderMedium
                        data={props.data}
                        filters={props.filters}
                        getImageFromStorage={getImageFromStorage}
                        handleFilters={handleFilters}
                        locale={locale}
                        categoriesOption={categoriesOption}
                        regionsOption={regionsOption}
                        regions={regions}
                        eventsCount={eventsCount}
                        eventsTypeArr={eventsTypeArr}
                        isDesktop={isDesktop}
                    />
        )
    }
}

export default Header;